<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard-layout
          ref="formWizard"
          @setVarieties="setVarieties"
          @showHideLoading="showHideLoading"
          @on-validated="onStepValidated"
          @on-complete="storeUpdateFarm"
          :tabsContent="tabsContent"
          v-if="this.isCreate() || this.isUpdate()"
        >
          <template slot="dataConfirm">
            <step-confirm
              :infoData="model"
              :center="center"
              ref="stepConfirm"
            />
          </template>
        </form-wizard-layout>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}:
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import axios from 'axios';
import FifthStep from './steps/FifthStep.vue';
import FirstStep from './steps/FirstStep.vue';
import FormWizard from 'src/components/Layouts/FormWizard.vue';
import FourthStep from './steps/FourthStep.vue';
import i18n from 'src/i18n';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from './steps/SecondStep.vue';
import StepConfirm from './steps/StepConfirm.vue';
import SweetAlert from 'src/class/Alerts';
import ThirdStep from './steps/ThirdStep.vue';

export default {
  components: {
    [FormWizard.name]: FormWizard,
    FirstStep,
    SecondStep,
    ThirdStep,
    FourthStep,
    FifthStep,
    StepConfirm,
  },
  data() {
    return {
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      model: {
        calendar_id: 1,
        name_blocks: [],
        lots_rel: [],
        nameDevices: [],
        names_business: [],
        names_files: [],
        other_values: [],
      },
    };
  },

  mixins: [MixinLoading, MixinMenu, MixinPermissions, MixinAlert],
  computed: {
    tabsContent() {
      return [
        {
          title: i18n.t('common_words.general_information'),
          reference: 'firstStep',
          component: FirstStep,
        },
        {
          title: i18n.t('common_words.ubication'),
          reference: 'secondStep',
          component: SecondStep,
        },
        {
          title: i18n.t('common_words.administrative'),
          reference: 'thirdStep',
          component: ThirdStep,
        },
        {
          title: i18n.t('common_words.crop'),
          reference: 'fourthStep',
          component: FourthStep,
        },
        {
          title: i18n.t('common_words.division'),
          reference: 'fifthStep',
          component: FifthStep,
        },
      ];
    },
  },
  methods: {
    setVarieties(varieties) {
      this.$refs.formWizard.$refs.fifthStep[0].crop_varieties = varieties;
    },
    cleanAllSteps() {
      this.$refs.formWizard.$refs.firstStep[0].model = {
        ...this.$refs.formWizard.$refs.firstStep[0].initialModel,
        businesses_id: [],
      };
      this.$refs.formWizard.$refs.firstStep[0].$refs[
        'select-businesses'
      ].model = {
        associations_ids: [],
        businesses_ids: [],
        names: [],
      };
      this.$refs.formWizard.$refs.secondStep[0].model = {
        ...this.$refs.formWizard.$refs.secondStep[0].initialModel,
        other_values: [],
        listFiles: {
          Perimetro: [],
          Bloques: [],
          Lotes: [],
          Drenaje: [],
          Suelo: [],
          CableVia: [],
          Reservorio: [],
          Construcciones: [],
        },
      };
      this.$refs.formWizard.$refs.thirdStep[0].model = {
        ...this.$refs.formWizard.$refs.thirdStep[0].initialModel,
      };
      this.$refs.formWizard.$refs.fourthStep[0].model = {
        ...this.$refs.formWizard.$refs.fourthStep[0].initialModel,
      };
      this.$refs.formWizard.$refs.fifthStep[0].model = {
        ...this.$refs.formWizard.$refs.fifthStep[0].initialModel,
        id_blocks: [],
        name_blocks: [],
        id_lots: [],
        name_lots: [],
        area_lots: [],
        crop_varieties_id: [],
        blocks_rel: [],
        lots_rel: [],
      };
      this.model = {
        calendar_id: 1,
        name_blocks: [],
        lots_rel: [],
        nameDevices: [],
        names_business: [],
        names_files: [],
        other_values: [],
      };
    },
    onStepValidated(dataModel) {
      this.model = { ...this.model, ...dataModel };
      this.center.lat = this.model.latitude
        ? parseFloat(this.model.latitude)
        : this.center.lat;
      this.center.lng = this.model.longitude
        ? parseFloat(this.model.longitude)
        : this.center.lng;
      this.fillFiles();
      this.$refs.stepConfirm.loadMap();
    },
    storeUpdateFarm() {
      this.showHideLoading(true);
      this.model.route = 'farms/farms';
      this.fillFiles();

      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.model.id = JSON.parse(sessionStorage.getItem('editForm')).id;
          Axios.updateMaster(this.model)
            .then((response) => {
              if (this.model.names_files.length > 0)
                axios.post('/auth/farms/farms/movekml', {
                  name: this.model.names_files,
                  farm: this.model.id,
                  user: this.$store.state.auth.user.id,
                });

              this.showHideLoading();
              SweetAlert.continue(
                response.data.message ? response.data.message : response.errors
              ).then((result) => {
                if (result.value) {
                  try {
                    this.$refs.formWizard.$refs.wizard.reset();
                  } catch (error) {}
                  this.cleanAllSteps();
                  sessionStorage.removeItem('editForm');
                } else if (result.dismiss) {
                  this.$router.push('/farms/farms');
                }

                return result;
              });
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.model)
            .then((response) => {
              if (this.model.names_files.length > 0)
                axios.post('/auth/farms/farms/movekml', {
                  name: this.model.names_files,
                  farm: response.data.data.id,
                  user: this.$store.state.auth.user.id,
                });

              this.showHideLoading();
              SweetAlert.continue(
                response.data.message ? response.data.message : response.errors
              ).then((result) => {
                if (result.value) {
                  try {
                    this.$refs.formWizard.$refs.wizard.reset();
                  } catch (error) {}
                  this.cleanAllSteps();
                  sessionStorage.removeItem('editForm');
                } else if (result.dismiss) {
                  this.$router.push('/farms/farms');
                }

                return result;
              });
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
    fillFiles() {
      this.model.names_files = [];
      let lfTmp = JSON.parse(localStorage.getItem('listFiles'));

      for (const key in lfTmp) {
        if (Object.hasOwnProperty.call(lfTmp, key)) {
          const element = lfTmp[key];
          if (element && element[0] && element.length > 0) {
            this.model.names_files.push(key);
          }
        }
      }
    },
  },
  mounted() {
    this.selectedItemOnMenu('farms/crops');
  },
  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('farms/crops');
  },
};
</script>
